import { CoachAssignedProps } from '../$schoolId/students';
import { CustomDialog } from '@/components/ui/custom-dialog';

interface DialogCoachesAssignedProps extends CoachAssignedProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export function DialogCoachesAssigned({
  availableCoachesCount,
  coachesAssignedCount,
  open,
  setOpen,
}: DialogCoachesAssignedProps) {
  if (availableCoachesCount < 0 || coachesAssignedCount < 0) {
    return null;
  }

  const assignmentTexts = (count: number) => {
    if (count <= 0) {
      return {
        title: 'No teachers were assigned',
        description: "Check the teachers' information and availability before assigning them manually.",
      };
    }

    const [plural, verb] = count === 1 ? ['', 'was'] : ['s', 'were'];

    return {
      title: `Teacher${plural} assigned`,
      description: `${count} available teacher${plural} ${verb} assigned automatically.`,
    };
  };

  const { title, description } = assignmentTexts(coachesAssignedCount);

  return <CustomDialog title={title} text={description} open={open} setOpen={setOpen} closeButtonText="Close" />;
}
